module.exports = __webpack_public_path__ + "img/footerlogo.089b8872.png";